import React, { useState, useCallback, useEffect, useContext } from 'react';

import { CustomerDetail } from '../../types';
import { CentrifugoContext } from '../CentrifugoContext';

import { CustomerContext, Customer } from './CustomerContext';

const CustomerContextProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [selectedCustomer, setSelectedCustomerState] = useState<Customer | null>(null);
  const [customerDetail, setCustomerDetailState] = useState<CustomerDetail | null>(null);
  const centrifugo = useContext(CentrifugoContext);

  // Simple setter - localStorage is managed at page level
  const setSelectedCustomer = useCallback((customer: Customer | null) => {
    setSelectedCustomerState(customer);
  }, []);

  const setCustomerDetail = useCallback((detail: CustomerDetail | null) => {
    setCustomerDetailState(detail);
  }, []);

  // Subscribe to Centrifugo channel for currently selected customer
  // This ensures we receive real-time updates even if the customer is not assigned to us
  useEffect(() => {
    if (!selectedCustomer?.id || !centrifugo?.subscribeToCustomer) {
      return;
    }

    const unsubscribe = centrifugo.subscribeToCustomer(selectedCustomer.id);
    return unsubscribe;
  }, [selectedCustomer?.id, centrifugo]);

  const contextValue = {
    selectedCustomer,
    setSelectedCustomer,
    customerDetail,
    setCustomerDetail,
  };

  return <CustomerContext.Provider value={contextValue}>{children}</CustomerContext.Provider>;
};

export default CustomerContextProvider;
